import { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://link.msgsndr.com/js/form_embed.js";

function ensureScript() {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
    // Re-run embed initializer if already present
    if (window.LC_embed) {
      try { window.LC_embed(); } catch (e) { /* noop */ }
    }
    return;
  }
  const s = document.createElement("script");
  s.src = SCRIPT_SRC;
  s.async = true;
  document.body.appendChild(s);
}

// Renders a GoHighLevel LeadConnector form inside an elegant, brand-styled frame.
export default function GoHighLevelForm({ formId, formName, height = 809, testId = "ghl-form" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    ensureScript();
  }, [formId]);

  const iframeHtml = `<iframe src="https://api.leadconnectorhq.com/widget/form/${formId}" style="width:100%;height:${height}px;border:none;border-radius:4px;display:block;" id="inline-${formId}" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="${formName}" data-height="${height}" data-layout-iframe-id="inline-${formId}" data-form-id="${formId}" title="${formName}"></iframe>`;

  return (
    <div
      data-testid={testId}
      ref={containerRef}
      className="relative bg-white border border-gold/40 shadow-[0_30px_80px_-40px_rgba(11,19,43,0.35)] rounded-sm p-3 sm:p-6 md:p-8"
    >
      {/* corner ticks */}
      <span className="pointer-events-none absolute left-3 top-3 h-5 w-5 border-l border-t border-gold/60" />
      <span className="pointer-events-none absolute right-3 top-3 h-5 w-5 border-r border-t border-gold/60" />
      <span className="pointer-events-none absolute left-3 bottom-3 h-5 w-5 border-l border-b border-gold/60" />
      <span className="pointer-events-none absolute right-3 bottom-3 h-5 w-5 border-r border-b border-gold/60" />
      <div dangerouslySetInnerHTML={{ __html: iframeHtml }} />
    </div>
  );
}
